import { $, $$ } from 'utils/dom';
import Swiperslider from 'modules/swiper/swiper';

const contactSliders = $$('.contact--slider');

if (contactSliders.length) {
  contactSliders.forEach(contactSlider => {
    const slider = new Swiperslider(
      $('.contact__item-wrapper', contactSlider),
      {
        container: contactSlider,
        sliderOptions: {
          spaceBetween: 30,
        },
      }
    );
    slider.init();
  });
}

const contactImageGrids = $$('.contact--swap-images');

if (contactImageGrids.length) {
  contactImageGrids.forEach(contactTeaser => {
    const contacts = $$('.contact__col', contactTeaser);
    contacts.forEach(contact => {
      const contactImages = $$('.contact__image', contact);
      contactImages.length === 2 &&
        contactImages[
          Math.floor(Math.random() * contactImages.length)
        ].classList.add('is-hidden');
    });
  });
}
